export default function NotificationsSettings() {
  return (
    <div>
      <h2>Notifications</h2>

      <div style={styles.card}>
        Notification settings coming soon
      </div>
    </div>
  );
}

const styles = {
  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    marginTop: "15px",
  },
};
